import { Payload, UseCase } from '@smile-next/uikit';

export class ConfirmedCloudIdPayload extends Payload {
    type = 'ConfirmedCloudIdPayload';
}

export class ConfirmCloudIdUseCase extends UseCase {
    execute() {
        this.dispatch(new ConfirmedCloudIdPayload());
    }
}
